import React from "react";
import "./Slot.css";

function Slot({ dayGroup }) {
  if (!dayGroup || !dayGroup.slots || dayGroup.slots.length === 0) {
    return null;
  }

  const firstTime = new Date(dayGroup.slots[0].time).toLocaleTimeString(
    "de-DE",
    {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }
  );

  return (
    <div className="slot">
      <div className="content">
        <h4>
          <span title={dayGroup.date}>{dayGroup.weekday}</span>
          <span className="separator">-</span>
          <span className="time">ab {firstTime} Uhr</span>
        </h4>
        <div className="day-slots">
          {dayGroup.slots.map((slot, index) => {
            return (
              <div key={slot.id || index} className="time-slot">
                <div className="image">
                  <a href={slot.link} target="_blank" rel="noopener noreferrer">
                    <img src={slot.imageUrl} alt={slot.title} />
                  </a>
                </div>
                <div className="slot-content">
                  <p>
                    <a
                      href={slot.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {slot.category && (
                        <span className="category">{slot.category} | </span>
                      )}
                      {slot.title}
                    </a>
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default Slot;
